import { Component, Input, OnInit, Output } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { GeneralService } from 'src/app/services/general.service';
@Component({
  selector: 'app-colis-card',
  templateUrl: './colis-card.component.html',
  styleUrls: ['./colis-card.component.scss'],
})
export class ColisCardComponent implements OnInit {
  @Input('selectedOption') selectedOption;
  @Input('colis') colis;
  @Output('Delete') Delete = new EventEmitter();
  @Output('Edit') Edit = new EventEmitter();
  @Input('userIsAllowedToDelete') userIsAllowedToDelete;
  constructor(private generalService: GeneralService) {}

  ngOnInit(): void {}
  toDelete(colis) {
    this.Delete.emit(colis);
  }
  toEdit(colis) {
    this.Edit.emit(colis);
  }
}
